<template>
  <i class="mc-icon icon-fill_checkmark"></i>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style scoped lang="scss">
.mc-icon {
  font-size: 20px;
  font-weight: 600;
}
</style>
